/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { defineMessages, useIntl } from 'react-intl-next';
import { useUser } from '../../../web-client/hooks/useUser';
import { useInlineContext } from '../../../context/inline';
import { default as PlatformAvatar, AvatarItem as PlatformAvatarItem } from '@atlaskit/avatar';
import { default as PlatformBadge } from '@atlaskit/badge';
var containerStyle = null;
var messages = defineMessages({
  unknownUser: {
    id: 'confluence.user.unknown.user.message',
    defaultMessage: 'Unknown User',
    description: 'This is a fallback message that displays when a username is not known.'
  }
});
var Avatar = function Avatar(_ref) {
  var name = _ref.name,
    picture = _ref.picture,
    hideDisplayName = _ref.hideDisplayName;
  if (hideDisplayName) {
    return /*#__PURE__*/React.createElement(PlatformAvatar, {
      name: name,
      src: picture
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1gzjidpf _1plv1j28 _1r3373ad"])
  }, /*#__PURE__*/React.createElement(PlatformAvatarItem, {
    avatar: /*#__PURE__*/React.createElement(PlatformAvatar, {
      name: name,
      src: picture
    }),
    primaryText: name
  }));
};
function UserInline(_ref2) {
  var name = _ref2.name;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(PlatformBadge, {
    appearance: "primary"
  }, name || intl.formatMessage(messages.unknownUser));
}
var User = function User(_ref3) {
  var accountId = _ref3.accountId,
    client = _ref3.client,
    hideDisplayName = _ref3.hideDisplayName;
  var _useUser = useUser(accountId, client),
    picture = _useUser.picture,
    name = _useUser.name;
  var _useInlineContext = useInlineContext(),
    inline = _useInlineContext.inline;
  if (!picture && !name) {
    return null;
  }
  if (inline) {
    return /*#__PURE__*/React.createElement(UserInline, {
      name: name
    });
  }
  return /*#__PURE__*/React.createElement(Avatar, {
    name: name,
    picture: picture,
    hideDisplayName: hideDisplayName
  });
};

// new approach requires ApolloClient as a prop
export var makeUser = function makeUser(_ref4) {
  var client = _ref4.client;
  return function UserFnNext(_ref5) {
    var props = _ref5.forgeDoc.props;
    var _ref6 = props,
      accountId = _ref6.accountId,
      hideDisplayName = _ref6.hideDisplayName;
    return /*#__PURE__*/React.createElement(User, {
      accountId: accountId,
      client: client,
      hideDisplayName: hideDisplayName
    });
  };
};